module.exports = __webpack_public_path__ + "static/media/results-project-new-2@2x.9fae8bf0.jpg";